import React from 'react';
export function HeroSection() {
  return <section className="relative pt-16 pb-20 px-6 md:pt-24 md:pb-32 overflow-hidden" data-id="element-209">
      <div className="max-w-3xl mx-auto text-center fade-in-up" data-id="element-210">
        <span className="inline-block py-1 px-3 rounded-full bg-[#D4C5A9]/20 text-[#2B4257] text-sm font-semibold tracking-wide mb-6 border border-[#D4C5A9]/50" data-id="element-211">
          FOR MEN 65+
        </span>

        <h1 className="text-4xl md:text-6xl font-bold text-[#2B4257] leading-[1.1] mb-6 tracking-tight" data-id="element-212">
          Downsize Without the{' '}
          <span className="italic text-[#6B9B8A]" data-id="element-213">"Maybe Piles."</span>
        </h1>

        <p className="text-xl md:text-2xl text-[#5A5A5A] mb-10 leading-relaxed max-w-2xl mx-auto font-light" data-id="element-214">
          A decision system for men who are done arguing with stuff. Keep your
          dignity. Finish the house.
        </p>

        <div className="mb-12 relative group" data-id="element-215">
          <div className="absolute -inset-1 bg-gradient-to-r from-[#D4C5A9] to-[#6B9B8A] rounded-lg blur opacity-25 group-hover:opacity-40 transition duration-1000" data-id="element-216"></div>
          <img src="https://cdn.magicpatterns.com/uploads/f67FWbbiHeJ8AHtQ4vmje8/heylloyd-image-1771090466847.png" alt="Downsizing Without Regret Premium Edition on a tablet" className="relative rounded-lg shadow-2xl border border-[#D4C5A9]/30 w-full max-w-md mx-auto transform transition duration-500 hover:scale-[1.01]" data-id="element-217" />
        </div>

        <div className="space-y-6 max-w-2xl mx-auto text-left md:text-center" data-id="element-218">
          <p className="text-lg text-[#1A1A1A] leading-relaxed" data-id="element-219">
            If you're staring at stacks of "maybe" piles… and every attempt to
            downsize turns into a longer weekend, a worse mood, and a shorter
            fuse—this is for you.
          </p>

          <p className="text-lg text-[#1A1A1A] leading-relaxed" data-id="element-220">
            Not because you need motivation.
          </p>

          <p className="text-lg text-[#1A1A1A] leading-relaxed font-semibold" data-id="element-221">
            Because you need a way to make decisions once—without shame, without
            family court, and without turning your life into a trash bag.
          </p>

          <p className="text-lg text-[#5A5A5A] leading-relaxed" data-id="element-222">
            <strong className="text-[#2B4257]" data-id="element-223">
              Downsizing Without Regret
            </strong>{' '}
            is a premium PDF playbook built for men 65+ who want to finish
            downsizing faster by eliminating decision paralysis and
            conflict—using a simple system:{' '}
            <strong className="text-[#6B9B8A]" data-id="element-224">
              Legacy Map + Decision Rules.
            </strong>
          </p>

          <div className="pt-4 flex justify-center" data-id="element-225">
            <a href="#pricing" className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white transition-all duration-200 bg-[#2B4257] rounded-md hover:bg-[#1f3040] hover:shadow-lg hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2B4257]" data-id="element-226">
              Get the Playbook — $6.36{' '}
              <span className="ml-2 line-through opacity-60 text-sm" data-id="element-227">$39</span>
            </a>
          </div>
        </div>
      </div>
    </section>;
}